module.exports = __webpack_public_path__ + "img/service-about-1.f91f2617.jpg";